import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of, catchError, zip, map } from 'rxjs';
import { PlansManagementService } from '../../../../shared/services/plans-management.service';
import { CustomCookieService } from '../../../../shared/services/custom-cookie.service';
import { ActivatedRoute } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class SelectPlanResolver implements Resolve<boolean> {
  constructor(
    private plansManagementService: PlansManagementService,
    private router: Router,
    private customCookieService: CustomCookieService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    return zip(
      this._getPlansList(route),
      this._getActivePlan()
    ).pipe(map(responses => {
      return {
        plansList: responses[0],
        activePlan: responses[1]
      }
    }))
  }

  _getPlansList(route: ActivatedRouteSnapshot) {
    const {mdn} = route.queryParams;
    this.customCookieService.saveData('ui-selectedMdn', mdn,'/', true);
    return this.plansManagementService.getPlansList(mdn).pipe(catchError(() => {
      this.router.navigate(['main/eligibility-error'])
      return 'Plans list empty for this MDN'
    }));
  }

  _getActivePlan() {
    return this.plansManagementService.getActivePlan()
  }


}
